/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_TrainInputs */

const en_us2_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train`)
};

const pt_br2_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar`)
};

const es_419_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenar`)
};

const pt_pt2_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar`)
};

const fr_fr2_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'entraîner`)
};

const de_de2_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainieren`)
};

const it_it2_shell_train = /** @type {(inputs: Shell_TrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenati`)
};

/**
* | output |
* | --- |
* | "Train" |
*
* @param {Shell_TrainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_train = /** @type {((inputs?: Shell_TrainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_TrainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_train(inputs)
	if (locale === "es-419") return es_419_shell_train(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_train(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_train(inputs)
	if (locale === "de-DE") return de_de2_shell_train(inputs)
	if (locale === "it-IT") return it_it2_shell_train(inputs)
	return en_us2_shell_train(inputs)
});
export { shell_train as "shell.train" }